export interface TranscriptLine {
  timestamp: string | null;
  text: string;
}

// Whisper output reaches us either bracketed ("[00:05] text"), bare
// ("00:05 text"), or with no timing at all — handle all three rather than
// inventing a placeholder when a line has no timestamp.
const TIMESTAMP_PATTERN = /^\[?((?:\d{1,2}:)?\d{1,2}:\d{2})\]?\s+(.*)$/;

export const parseTranscriptLines = (transcript: string | null): TranscriptLine[] =>
  (transcript || '')
    .split(/\r?\n/)
    .map(line => line.trim())
    .filter(Boolean)
    .map(line => {
      const match = line.match(TIMESTAMP_PATTERN);
      if (match && match[2].trim()) {
        return { timestamp: match[1], text: match[2].trim() };
      }
      return { timestamp: null, text: line };
    });
